export default {"src":"/_next/static/media/clouds_journey_intro.81a5aebc.svg","height":1080,"width":1920,"blurWidth":0,"blurHeight":0};